// src/store/slices/modeloSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../actions/configApi';

export const fetchModels = createAsyncThunk(
    'modelos/fetchModels',
    async (page = 1, { rejectWithValue }) => {
        try {
            const response = await api.get(`/modeloAll?page=${page}`); // Inclua a página na URL
           // const response = await api.get('modeloAll');
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data || 'Erro ao carregar modelos');
        }
    }
);

export const fetchModels2 = createAsyncThunk(
    'modelos/fetchModels2',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get(`/modeloAll2`); // Inclua a página na URL
           // const response = await api.get('modeloAll');
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data || 'Erro ao carregar modelos');
        }
    }
);

export const createModel = createAsyncThunk(
    'modelos/createModel',
    async ({ modelo,caracteristica, ordem }, { rejectWithValue }) => {
        try {
            const response = await api.post('/modeloValues', { modelo,caracteristica, ordem });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data.message || 'Erro ao criar modelo');
        }
    }
);

export const updateModel = createAsyncThunk(
    'modelos/updateModel',
    async ({ id, modeloEdit,selectedClassificationEdit, ordem }, { rejectWithValue }) => {
        try {
            const response = await api.put(`modeloUpdate/${id}`, { modeloEdit,selectedClassificationEdit, ordem });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data || 'Erro ao editar modelo');
        }
    }
);

export const deleteModel = createAsyncThunk(
    'modelos/deleteModel',
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.delete(`modeloDelete/${id}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data || 'Erro ao excluir modelo');
        }
    }
);

const modeloSlice = createSlice({
    name: 'modelos',
    initialState: {
        modelos: [],
        loading: false,
        loadingM: false,
        error: null,
        successMessage: null,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchModels.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchModels.fulfilled, (state, action) => {
                state.loading = false;
                state.modelos = action.payload.modelos;
            })
            .addCase(fetchModels.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(createModel.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createModel.fulfilled, (state, action) => {
                state.loading = false;
                state.modelos = action.payload.modelos;
                state.successMessage = action.payload.message;
            })
            .addCase(createModel.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(updateModel.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.successMessage = null;
            })
            .addCase(updateModel.fulfilled, (state, action) => {
                state.loading = false;
                state.modelos = action.payload.modelos;
                state.successMessage = action.payload.message;
            })
            .addCase(updateModel.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(deleteModel.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteModel.fulfilled, (state, action) => {
                state.loading = false;
                state.modelos = action.payload.modelos;
                state.successMessage = action.payload.message;
            })
            .addCase(deleteModel.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            //lisyagem em proditos
            .addCase(fetchModels2.pending, (state) => {
                state.loadingM = true;
                state.error = null;
            })
            .addCase(fetchModels2.fulfilled, (state, action) => {
                state.loadingM = false;
                state.modelos = action.payload.modelos;
            })
            .addCase(fetchModels2.rejected, (state, action) => {
                state.loadingM = false;
                state.error = action.payload;
            });
    },
});

export default modeloSlice.reducer;
